export default {
  data() {
    return {
      allData: [],       
      paginatedData: [], 
      currentPage: 1,
      pageSize: 25,
      search: null,
      paginate: {},
      paginatelinks: [],
    };
  },

  methods: {

    initializePagination(data, options = {}) {
      this.allData = Array.isArray(data) ? data : [];
      this.currentPage = options.currentPage || 1;
      this.pageSize = options.pageSize || this.pageSize;
      this.search = options.search || null;
      
      this.applyClientSidePagination();
    },

    applyClientSidePagination() {

      let filteredData = this.getFilteredData();

      // Calculate pagination
      const total = filteredData.length;
      const lastPage = Math.ceil(total / this.pageSize) || 1;
      const from = total > 0 ? ((this.currentPage - 1) * this.pageSize) + 1 : 0;
      const to = total > 0 ? Math.min(this.currentPage * this.pageSize, total) : 0;

      // Get current page data
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      this.paginatedData = filteredData.slice(startIndex, endIndex);

      // Set pagination info
      this.paginate = {
        from,
        to,
        total,
        current_page: this.currentPage,
        last_page: lastPage,
      };

      // Create pagination links
      this.paginatelinks = this.generatePaginationLinks(lastPage);
    },

    getFilteredData() {
      if (!this.search) {
        return this.allData;
      }

      const searchLower = this.search.toLowerCase();
      
      
      return this.allData.filter(item => {
        return Object.values(item).some(value => {
          if (typeof value === 'string') {
            return value.toLowerCase().includes(searchLower);
          }
          return false;
        });
      });
    },

    generatePaginationLinks(lastPage) {
      const links = [];
      
      // Previous button
      links.push({
        url: this.currentPage > 1 ? 'prev' : null,
        label: '&laquo; Previous',
        active: false,
      });

      // Page numbers
      for (let i = 1; i <= lastPage; i++) {
        links.push({
          url: `page-${i}`,
          label: String(i),
          active: i === this.currentPage,
        });
      }

      // Next button
      links.push({
        url: this.currentPage < lastPage ? 'next' : null,
        label: 'Next &raquo;',
        active: false,
      });

      return links;
    },

    handleSearch(searchItem) {
      this.search = searchItem;
      this.currentPage = 1;
      this.applyClientSidePagination();
    },

    // handle page size change
    handlePageSize(newPageSize) {
      this.pageSize = newPageSize || 25;
      this.currentPage = 1;
      this.applyClientSidePagination();
    },

    handlePageChange(pageNumber) {
      const lastPage = Math.ceil(this.paginate.total / this.pageSize);
      
      if (pageNumber >= 1 && pageNumber <= lastPage) {
        this.currentPage = pageNumber;
        this.applyClientSidePagination();
      }
    },

    // handle pagination click
    handlePaginationClick({ url }) {
      if (!url) return;

      if (url === 'prev') {
        if (this.currentPage > 1) {
          this.currentPage--;
          this.applyClientSidePagination();
        }
      } else if (url === 'next') {
        const lastPage = Math.ceil(this.paginate.total / this.pageSize);
        if (this.currentPage < lastPage) {
          this.currentPage++;
          this.applyClientSidePagination();
        }
      } else if (url.startsWith('page-')) {
        this.currentPage = parseInt(url.replace('page-', ''));
        this.applyClientSidePagination();
      }
    },

    resetPagination() {
      this.currentPage = 1;
      this.search = null;
      this.applyClientSidePagination();
    },
  },
};